import { Grid } from "@mui/material"
import React, { useCallback, useContext, useMemo } from "react"
import { FormNumberInput } from "../../../../../../../../../../../components/inputs/number-input/FormNumberInput"
import { NonEditableTextField } from "../../../../../../../../../../../components/inputs/text-input/NonEditableTextField"
import { levelNumberToLabel, stringToNumber } from "../../../../../../../../../../../core/services/helper-service"
import { BSLevelContext } from "../../../context/BSLevelContext"
import { GroupLevel } from "../../../context/GroupLevel"
import { BSLevelFormContext } from "../../../context/BSLevelFormContext"

interface IProps {
  groupLevel: GroupLevel
}

export function BSBuildingLevelGroupInfos({ groupLevel }: Readonly<IProps>): React.JSX.Element {
  const { setIsLevelUpdated } = useContext(BSLevelContext)
  const { setFormFieldValue, errors, validateNonZero, generateUniqueErrorKey } = useContext(BSLevelFormContext)

  const height = useMemo(() => groupLevel.levelList[0]?.height, [groupLevel.levelList])

  const handleChange = useCallback(
    (value: string): void => {
      validateNonZero(groupLevel.id, "height", stringToNumber(value))
      setFormFieldValue("height", stringToNumber(value), groupLevel.id, groupLevel.levelList[0].superstructure)
      setIsLevelUpdated(true)
    },
    [groupLevel.id, groupLevel.levelList, setFormFieldValue, setIsLevelUpdated, validateNonZero]
  )

  const fieldName = "height"
  const errorKey = generateUniqueErrorKey(groupLevel.id, fieldName)

  return (
    <Grid container display="flex" alignItems="center" columnSpacing={1} rowSpacing={1}>
      {groupLevel.levelList.length > 1 && (
        <Grid item xs={6}>
          <NonEditableTextField label="Niveau de départ" value={levelNumberToLabel(groupLevel.levelList[0].levelNumber)} />
        </Grid>
      )}
      <Grid item xs={6}>
        <FormNumberInput
          fieldName={fieldName}
          label="Hauteur (m)"
          value={height}
          handleChange={handleChange}
          errors={errors[errorKey] ? { [fieldName]: errors[errorKey] } : undefined}
        />
      </Grid>
    </Grid>
  )
}
